import React, { useMemo } from "react";
import { CallingTheme, ControlBarButton, useTheme } from "@azure/communication-react";
import { IRawStyle, mergeStyles, Theme } from "@fluentui/react";
import { tokens } from "@fluentui/react-components";
import { ChevronLeft20Regular, ChevronRight20Regular } from "@fluentui/react-icons";
import {
    pageButtonStyles,
} from "live-lesson/shared/feature-call-ui-react";

export interface PcpGalleryPagerProps {
    page: number;
    numPages: number;
    hasMultiplePages: boolean;
    goToPrevPage: () => void;
    goToNextPage: () => void;
    hasPrevPage: boolean;
    hasNextPage: boolean;
}


const galleryPagerStyles = {
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',

    } as IRawStyle ,
    label: {
        marginLeft: "16px",
        marginRight: "16px",
        color: tokens.colorNeutralStrokeOnBrand,
        weight: 700,
        fontSize: '1rem',
        fontFamily: 'Roboto',
        letterSpacing: '0.04em',
    } as IRawStyle
}

export function PcpGalleryPager(props: PcpGalleryPagerProps): JSX.Element {
    const themeV8 = useTheme() as Theme & CallingTheme;  //using value of "FluentThemeProvider" component
    const getPageButtonStyles = useMemo(() => pageButtonStyles(themeV8), [themeV8]);

    const iconStyle = {color: 'white'};
    const leftIcon = <ChevronLeft20Regular style={iconStyle}></ChevronLeft20Regular>;
    const rightIcon = <ChevronRight20Regular style={iconStyle}></ChevronRight20Regular>;

    return <div className={mergeStyles(galleryPagerStyles.root)}>
        <ControlBarButton
            onClick={props.goToPrevPage}
            disabled={!props.hasPrevPage}
            checked={true}
            styles={getPageButtonStyles}
            onRenderOnIcon={() => leftIcon}
            onRenderOffIcon={() => leftIcon} />
        {/* `galleryPage` is indexed by 0 */}
        <span className={mergeStyles(galleryPagerStyles.label)}>{props.page + 1}/{props.numPages}</span>
        <ControlBarButton
            onClick={props.goToNextPage}
            disabled={!props.hasNextPage}
            checked={true}
            styles={getPageButtonStyles}
            onRenderOnIcon={() => rightIcon}
            onRenderOffIcon={() => rightIcon} />
    </div>;
}
